import { degreeToRadiansUseCase } from './degrees-to-radians.use-case';

interface Coordinates {
    latitude: number;
    longitude: number;
}

const R = 6378137; // Earth’s mean radius in meter

export function calcDistanceBetweenUseCase(p1: Coordinates, p2: Coordinates): number {
    const dLat = degreeToRadiansUseCase(p2.latitude - p1.latitude);
    const dLong = degreeToRadiansUseCase(p2.longitude - p1.longitude);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(degreeToRadiansUseCase(
            p1.latitude
        )) * Math.cos(degreeToRadiansUseCase(p2.latitude)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d; // returns the distance in meters
}
